import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="acceder" ref={ref} className="py-28 px-4 relative overflow-hidden" style={{
    background: 'var(--color-bg)'
  }} data-id="element-38">
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 70% 60% at 50% 50%, rgba(78,205,196,0.07) 0%, transparent 70%)'
    }} data-id="element-39" />

      <div className="relative z-10 max-w-2xl mx-auto text-center" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="mb-10" data-id="element-41">
          <p className="text-sm font-semibold tracking-widest uppercase mb-6" style={{
          color: 'var(--color-accent)'
        }} data-id="element-42">
            La pregunta final
          </p>

          <h2 className="text-3xl md:text-5xl font-black mb-8 leading-tight" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-43">
            El paso no se da solo.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        delay: 0.3,
        duration: 0.7
      }} className="space-y-3 mb-12" data-id="element-44">
          <p className="text-lg" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-45">
            Llevas tiempo consumiendo.
          </p>
          <p className="text-lg" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-46">
            Llevas tiempo esperando el momento correcto.
          </p>
          <p className="text-lg" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-47">
            Llevas tiempo sintiéndote a un paso de algo más grande.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.5,
        duration: 0.7
      }} className="mb-12" data-id="element-48">
          <p className="text-lg leading-relaxed mb-4" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-49">
            Crecimiento AudioPro es ese sistema.
          </p>
          <p className="text-xl font-bold" style={{
          color: 'var(--color-text)'
        }} data-id="element-50">
            No para personas que quieren inspiración.{' '}
            <span style={{
            color: 'var(--color-accent)'
          }} data-id="element-51">
              Para personas que quieren resultados internos reales.
            </span>
          </p>
        </motion.div>

        {/* Steps */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.6,
        duration: 0.7
      }} className="mb-12" data-id="element-52">
          <div className="p-8 rounded-sm text-left" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-53">
            <p className="text-base mb-4" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-54">
              Empieza con un libro.
            </p>
            <p className="text-base mb-4" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-55">
              Escucha un audiolibro en tu próximo trayecto.
            </p>
            <p className="text-base mb-6" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-56">
              Haz una meditación estratégica esta noche.
            </p>
            <p className="text-xl font-black" style={{
            fontFamily: 'Playfair Display, serif',
            color: 'var(--color-text)'
          }} data-id="element-57">
              Pero empieza.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.8,
        duration: 0.5
      }} className="mb-6" data-id="element-58">
          <a href="https://hotmart.com" target="_blank" rel="noopener noreferrer" className="cta-button inline-flex items-center gap-3 px-10 py-6 text-base rounded-sm" data-id="element-59">
            <span data-id="element-60">Accede Ahora a Crecimiento AudioPro</span>
            <ArrowRightIcon className="w-5 h-5" data-id="element-61" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        delay: 1,
        duration: 0.6
      }} data-id="element-62">
          <p className="text-lg font-black italic" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text-muted)'
        }} data-id="element-63">
            Tu siguiente versión no aparece sola.{' '}
            <span style={{
            color: 'var(--color-accent)'
          }} data-id="element-64">
              Se instala.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}